function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import messages from '../../messages';
import styles from './ImportsHistory.pcss';
const ColHeaders = ()=>/*#__PURE__*/ _jsxs("div", {
        className: styles.table__headers,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.table__col,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.timeOfImport))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.table__col,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.dateRange))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.table__col, styles['table__col--small']),
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.readings))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.table__col, styles['table__col--small']),
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.source))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.table__col, styles['table__col--small']),
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tableLabels.filterChart))
            })
        ]
    });
export default ColHeaders;
